// extracted by mini-css-extract-plugin
export default {"root":"RiKnSW_RbEkUs6wqVGnb undefined","header":"nlnO8qF28XVUGOV70iyy","title":"jSCLk1kTVvxPz5b1Ilbo","section":"DVRuDWmIn4bV8tAW56zX","loading":"zt8OdSv91yE9r2bpw_ha"};